module.exports = __webpack_public_path__ + "9954da99d1ab444bd5ace1a1c7064251.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-31.png
// module id = 2610
// module chunks = 0